(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["wavelength-module"] && !Shopify.designMode) return;
  try {
    
  class WavelengthModule extends HTMLElement {
    connectedCallback() {
      this.wrapper = this.querySelector('[data-wl-wrapper]');
      this.activeBlock = this.querySelector('[data-wl-active]');
      this.activeText = this.querySelector('[data-wl-active-text]');
      this.rings = Array.from(this.querySelectorAll('[data-wl-ring]'));
      this.tabs = Array.from(this.querySelectorAll('[data-wl-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-wl-panel]'));
      this.index = 0;
      this.timer = null;
      this.swapTimeout = null;

      if (!this.rings.length) return;

      this.tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => {
          this.goTo(i);
          this.restart();
        });
        tab.addEventListener('keydown', (event) => this.onKeydown(event, i));
      });

      const prev = this.querySelector('[data-wl-prev]');
      const next = this.querySelector('[data-wl-next]');
      if (prev)
        prev.addEventListener('click', () => {
          this.step(-1);
          this.restart();
        });
      if (next)
        next.addEventListener('click', () => {
          this.step(1);
          this.restart();
        });

      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', (event) => {
        if (!this.contains(event.relatedTarget)) this.start();
      });

      this.update(0, true);

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(
          (entries) => {
            entries[0].isIntersecting ? this.start() : this.stop();
          },
          { threshold: 0.2 }
        );
        this.observer.observe(this);
      } else {
        this.start();
      }
    }

    disconnectedCallback() {
      this.stop();
      clearTimeout(this.swapTimeout);
      if (this.observer) this.observer.disconnect();
    }

    get isRTL() {
      return getComputedStyle(this).direction === 'rtl';
    }

    update(index, initial) {
      this.index = (index + this.rings.length) % this.rings.length;
      const current = this.rings[this.index];
      const depth = current.dataset.depth + '%';
      const color = current.dataset.color;
      const label = current.dataset.label;

      this.rings.forEach((ring, i) => {
        ring.classList.toggle('selected', i <= this.index);
      });

      this.tabs.forEach((tab, i) => {
        tab.setAttribute('aria-expanded', i === this.index ? 'true' : 'false');
      });

      this.panels.forEach((panel, i) => {
        panel.classList.toggle('selected', i === this.index);
      });

      this.activeBlock.style.setProperty('--circle-size', depth);

      if (initial) {
        this.activeBlock.style.setProperty('--circle-color', color);
        this.activeText.textContent = label;
        return;
      }

      // Shrink the old value out, swap it, scale the new one in.
      clearTimeout(this.swapTimeout);
      this.activeText.classList.add('scale-out');
      this.swapTimeout = setTimeout(() => {
        this.activeBlock.style.setProperty('--circle-color', color);
        this.activeText.textContent = label;
        this.activeText.classList.remove('scale-out');
      }, 500);
    }

    animate() {
      if (!this.wrapper) return;
      this.wrapper.classList.remove('animate-start');
      void this.wrapper.offsetHeight; // force reflow so the animation replays
      this.wrapper.classList.add('animate-start');
    }

    goTo(index) {
      this.update(index);
      this.animate();
    }

    step(direction) {
      this.goTo(this.index + direction);
    }

    onKeydown(event, currentTabIndex) {
      const forward = this.isRTL ? 'ArrowLeft' : 'ArrowRight';
      const back = this.isRTL ? 'ArrowRight' : 'ArrowLeft';
      let target = null;

      if (event.key === forward || event.key === 'ArrowDown') target = currentTabIndex + 1;
      else if (event.key === back || event.key === 'ArrowUp') target = currentTabIndex - 1;
      else if (event.key === 'Home') target = 0;
      else if (event.key === 'End') target = this.rings.length - 1;
      else return;

      event.preventDefault();
      const next = (target + this.tabs.length) % this.tabs.length;
      this.goTo(next);
      this.tabs[next].focus();
      this.restart();
    }

    start() {
      if (!this.hasAttribute('data-autoplay') || this.rings.length < 2) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.stop();
      const interval = parseInt(this.dataset.interval, 10) || 5000;
      this.timer = setInterval(() => this.step(1), interval);
    }

    stop() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }

    restart() {
      this.stop();
      this.start();
    }
  }

  if (!customElements.get('wavelength-module')) {
    customElements.define('wavelength-module', WavelengthModule);
  }

  } catch(e) { console.error(e); }
})();
})();
